// removed by extract-text-webpack-plugin
module.exports = {"component":"_2HAUsJUffdM-AoQx_fb6L8"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Cart/MainForm/Payment/payment.css
// module id = 1105
// module chunks = 2